export enum ProgramRole {
  Trainee,
  Trainer,
  Supervisor,
  Coordinator
}
